module.exports = __webpack_public_path__ + "img/title-dg.9ee0ff16.png";